import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Translate } from 'react-jhipster';
import { AUTHORITIES } from 'app/config/constants';
import { IPurchaseCancellation } from 'app/shared/model/purchase-cancellation.model';
import { IQuotation } from 'app/shared/model/quotation.model';
import { IUser } from 'app/shared/model/user.model';
import { Button, Label } from 'reactstrap';

interface RequestCancellationModalProps {
  open: boolean;
  onClose: () => void;
  maxWidth: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  poId: string;
  account: any;
  error: boolean;
  helperText: boolean;
  purchaseCancellation: IPurchaseCancellation;
  requestCancellationReason: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  manager: IUser;
  alshmokhAdmin: IUser;
  quotationEntity: IQuotation;
  element: JSX.Element;
  onClick: () => void;
  disabled: boolean;
}

// TODO refactor to reduce input params and move data into internal state where possible
const RequestCancellationDialog: React.FC<RequestCancellationModalProps> = ({
  open,
  onClose,
  maxWidth,
  poId,
  account,
  error,
  helperText,
  purchaseCancellation,
  requestCancellationReason,
  onChange,
  manager,
  alshmokhAdmin,
  quotationEntity,
  element,
  onClick,
  disabled,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle style={{ fontWeight: 'bold' }}>
        <Grid container spacing={2}>
          <Grid item xs={10} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
            <Translate contentKey="comexApp.quotation.cancellationModal.requestCancellationLabel" interpolate={{ poId }} />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              top: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
        <DialogContentText style={{ color: 'black' }} className="mb-3">
          {account?.authorities.includes(AUTHORITIES.BANK_STAFF) ? (
            <Translate contentKey="comexApp.quotation.cancellationModal.provideReason" />
          ) : (
            <Translate contentKey="comexApp.quotation.cancellationModal.reason" />
          )}{' '}
          :
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="reason"
          type="text"
          fullWidth
          multiline
          error={error}
          helperText={helperText}
          rows={5}
          variant="outlined"
          className="mb-2"
          value={
            account?.authorities?.includes(AUTHORITIES.BRANCH_MANAGER) ||
            account?.authorities?.includes(AUTHORITIES.ALSHMOKH_ADMIN) ||
            account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER)
              ? purchaseCancellation?.reason
              : requestCancellationReason
          }
          onChange={onChange}
          disabled={purchaseCancellation.reason ? true : false}
        />
        <DialogContentText style={{ color: 'black' }} component={'span'}>
          <div>
            {purchaseCancellation?.managerApproval === true && (
              <>
                <Label style={{ fontWeight: 'bold' }}>
                  <Translate contentKey="comexApp.quotation.approvedBy" />
                </Label>{' '}
                : {manager?.id ? `${manager?.firstName} ${manager?.lastName}` : '-'}&nbsp;(
                <Translate contentKey="comexApp.bank.details.branchManager" />)
              </>
            )}
          </div>
          <div>
            {purchaseCancellation?.managerApproval === false && (
              <>
                <Label style={{ fontWeight: 'bold' }}>
                  <Translate contentKey="comexApp.quotation.deniedBy" />
                </Label>{' '}
                : {manager?.id ? `${manager?.firstName} ${manager?.lastName}` : '-'}&nbsp;(
                <Translate contentKey="comexApp.bank.details.branchManager" />)
              </>
            )}
          </div>
          <div>
            {purchaseCancellation?.comexAdminApproval === true && (
              <>
                <Label style={{ fontWeight: 'bold' }}>
                  <Translate contentKey="comexApp.quotation.approvedBy" />
                </Label>{' '}
                : {alshmokhAdmin?.firstName + ' ' + alshmokhAdmin?.lastName}&nbsp;(
                {alshmokhAdmin?.authorities?.includes(AUTHORITIES.ALSHMOKH_ADMIN) ? (
                  <Translate contentKey="comexApp.quotation.alshmokhAdmin" />
                ) : (
                  <Translate contentKey="comexApp.quotation.alshmokhStaff" />
                )}
                )
              </>
            )}
          </div>
          <div>
            {purchaseCancellation?.comexAdminApproval === false && (
              <>
                <Label style={{ fontWeight: 'bold' }}>
                  <Translate contentKey="comexApp.quotation.deniedBy" />
                </Label>{' '}
                : {alshmokhAdmin?.firstName + ' ' + alshmokhAdmin?.lastName}&nbsp;(
                {alshmokhAdmin?.authorities?.includes(AUTHORITIES.ALSHMOKH_ADMIN) ? (
                  <Translate contentKey="comexApp.quotation.alshmokhAdmin" />
                ) : (
                  <Translate contentKey="comexApp.quotation.alshmokhStaff" />
                )}
                )
              </>
            )}
          </div>
          <div>
            {purchaseCancellation?.comexAdminApproval === true && purchaseCancellation.result === 'CANCELLED' ? (
              <Label style={{ fontWeight: 'bold' }}>
                <Translate contentKey="comexApp.quotation.bursaDecision" /> : {purchaseCancellation?.result}
              </Label>
            ) : (
              <></>
            )}
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions className="mx-3 mb-3">
        <Button variant="contained" id="save-entity" data-cy="entityCreateSaveButton" onClick={onClose}>
          <Translate contentKey="comexApp.quotation.cancelBtnLabel">Cancel</Translate>
        </Button>
        &nbsp;
        {quotationEntity?.cancelOrder === true &&
        (account?.authorities?.includes(AUTHORITIES.BRANCH_MANAGER) ||
          account?.authorities?.includes(AUTHORITIES.ALSHMOKH_ADMIN) ||
          account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) ||
          account?.authorities?.includes(AUTHORITIES.SUBADMIN_CANCELLATION)) ? (
          element
        ) : (
          <Button color="primary" id="save-entity" data-cykeep="entityCreateSaveButton" type="submit" onClick={onClick} disabled={disabled}>
            <Translate contentKey="comexApp.quotation.requestCancellation">Request Cancellation</Translate>
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default RequestCancellationDialog;
